'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002412 from "./presto.-Register-Page-View$$anon$12.js";
import * as $j_presto$002etypes$0024$002dCompact$002dFeature$0024 from "./presto.types$-Compact-Feature$.js";
import * as $j_presto$002etypes$0024$002dFeature$002dCode$0024 from "./presto.types$-Feature-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$11() {
  this.bto = null;
  this.btg = null;
  this.bth = false;
  this.btp = null;
  this.btq = false;
  this.btt = null;
  this.btm = null;
  this.btn = false;
  this.bti = null;
  this.btj = false;
  this.btk = null;
  this.btl = false;
  this.btr = false;
  this.bts = false;
  this.bto = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.btt = "CompactFeature";
}
export { $c_Lpresto_RegisterPageView$$anon$11 as $c_Lpresto_RegisterPageView$$anon$11 };
$p = $c_Lpresto_RegisterPageView$$anon$11.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$11;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$11() {
}
export { $h_Lpresto_RegisterPageView$$anon$11 as $h_Lpresto_RegisterPageView$$anon$11 };
$h_Lpresto_RegisterPageView$$anon$11.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bto;
});
$p.L = (function() {
  if ((!this.bth)) {
    this.btg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bth = true;
  }
  return this.btg;
});
$p.O = (function() {
  if ((!this.btq)) {
    this.btp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.btq = true;
  }
  return this.btp;
});
$p.E = (function() {
  return this.btt;
});
$p.t = (function() {
  if ((!this.btn)) {
    this.btm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("value", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.btn = true;
  }
  return this.btm;
});
$p.M = (function() {
  if ((!this.btj)) {
    this.bti = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dFeature$002dCode$0024.$m_Lpresto_types$FeatureCode$().adu(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.btj = true;
  }
  return this.bti;
});
$p.Q = (function() {
  if ((!this.btl)) {
    this.btk = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002412.$c_Lpresto_RegisterPageView$$anon$12();
    this.btl = true;
  }
  return this.btk;
});
$p.w = (function() {
  if ((!this.bts)) {
    this.btr = false;
    this.bts = true;
  }
  return this.btr;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee92) => ((p) => \u03b4scrutinee92.ad8(p)))($j_presto$002etypes$0024$002dCompact$002dFeature$0024.$m_Lpresto_types$CompactFeature$())));
});
var $d_Lpresto_RegisterPageView$$anon$11 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$11, "presto.RegisterPageView$$anon$11", ({
  PT: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$11 as $d_Lpresto_RegisterPageView$$anon$11 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$11.js.map
